/**
 * Canonical form for collab entity/doc ids (screen + workflow GUIDs).
 *
 * Every identity guard added for KOA-18173 compares ids that reach the client through
 * DIFFERENT channels — the URL path, screen-list DTOs, the tree JSON's root id, the
 * session's join-time entity id. They name the same GUID but are not guaranteed to be
 * byte-identical strings (case, stray whitespace). The server compares parsed Guids
 * (case-insensitive), so a client-side `===` on raw strings can disagree with the
 * server: the save then falls back to the whole-tree PUT and the user's OWN live
 * session rejects it with 409 CollabActive. Always compare through this helper.
 */
export function normalizeCollabId(id: string | null | undefined): string {
  if (id == null) return "";
  return String(id).trim().toLowerCase();
}

export function collabIdsEqual(a: string | null | undefined, b: string | null | undefined): boolean {
  const left: string = normalizeCollabId(a);
  const right: string = normalizeCollabId(b);
  if (left === "" || right === "") return false;
  return left === right;
}
